// Vuex connections module mutations

import { FILL_LIST, FILL_LIST_COUNT, FILL_CALENDAR } from "./mutations-types";

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.plannerList = payload.records;
  },
  [FILL_LIST_COUNT](state, payload) {
    const _state = state;
    _state.plannerListCount = payload.count;
  },
  [FILL_CALENDAR](state, payload) {
    const _state = state;
    _state.calendarEventsList = payload;
  }
};
